module.exports = __webpack_public_path__ + "static/media/style.12b83adb.less";